import React from "react";
import MainContainer from '../app/web/containers/MainContainer/MainContainer';

export const AppConfig: React.FunctionComponent<any> = (props: any) => {
  return <MainContainer {...props} />
};